import React, { FC } from 'react'
import LabelBox from 'components/base-ui/LabelBox'
import spacing from 'styles/spacing'
import { useTranslation } from 'react-i18next'

interface InvalidBoxProps {
  productName?: string
  isNotFound: boolean
  listModifierIsNotFound: string[]
  isMembershipRequiredItem: boolean
  isTierIneligibleItem: boolean
  isTierBirthMonthRequiredItem: boolean
  isModifierNotFound: boolean
  isGeneralInvalid: boolean
}

const style = {
  marginTop: `${spacing.sm}px`,
  gridColumn: 'span 3',
}

const InvalidList: FC<InvalidBoxProps> = ({
  isNotFound,
  productName = '',
  listModifierIsNotFound = [],
  isMembershipRequiredItem,
  isTierIneligibleItem,
  isTierBirthMonthRequiredItem,
  isModifierNotFound,
  isGeneralInvalid,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      {isMembershipRequiredItem && (
        <LabelBox
          style={style}
          title={t('lineItemsWarningInvalidMembershipRequired')}
          text={t('lineItemsWarningInvalidMembershipRequiredDes')}
          type="errorLight"
        />
      )}

      {isTierIneligibleItem && (
        <LabelBox
          style={style}
          title={t('lineItemWarningIneligibleTitle', { productName })}
          text={t('lineItemWarningInactiveDes')}
          type="errorLight"
        />
      )}
      {isTierBirthMonthRequiredItem && (
        <LabelBox
          style={style}
          title={t('lineItemsWarningInvalidBirthMonthRequired', { productName })}
          text={t('lineItemsWarningInvalidBirthMonthRequiredDes')}
          type="errorLight"
        />
      )}

      {isNotFound && (
        <LabelBox
          style={style}
          title={t('lineItemsWarningInvalidInactiveTitle')}
          text={t('lineItemsWarningInvalidInactiveDes')}
          type="errorLight"
        />
      )}

      {isModifierNotFound && (
        <LabelBox
          style={style}
          title={t('lineItemsWarningInvalidModifierInactiveTitle', {
            modifiersName: listModifierIsNotFound.join(','),
          })}
          text={t('lineItemsWarningInvalidModifierInactiveDes')}
          type="errorLight"
        />
      )}

      {!isNotFound && isGeneralInvalid && (
        <LabelBox
          style={style}
          title={t('lineItemsWarningInvalidGeneral')}
          text={t('lineItemsWarningInvalidGeneralDesc')}
          type="errorLight"
        />
      )}
    </div>
  )
}

export default InvalidList
